import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
// wowjs
// import 'wowjs/css/libs/animate.css'
import 'wowjs/css/libs/animate.css'
import wow from 'wowjs'
Vue.prototype.$wow = wow
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
